import { Box, Tab, Tabs, Typography } from '@mui/material';
import { useState } from 'react';
import { IPropsBusinessPage } from '../Business';
import { BusinessPackagesManage } from './BusinessPackagesManage';
import { BusinessClientPackages } from './BusinessClientPackages';

export const BusinessPackages: React.FC<IPropsBusinessPage> = ({ business, refetch }) => {
  const [tabIndex, setTabIndex] = useState(0);

  return (
    <Box display='flex' flexDirection='column' gap={3}>
      <Typography variant='h6'>Pacotes de Serviços</Typography>

      <Tabs
        value={tabIndex}
        onChange={(_, v) => setTabIndex(v)}
        sx={{ borderBottom: 1, borderColor: 'divider' }}
      >
        <Tab label='Gerenciar Pacotes' />
        <Tab label='Clientes' />
      </Tabs>

      {tabIndex === 0 && <BusinessPackagesManage business={business} refetch={refetch} />}
      {tabIndex === 1 && <BusinessClientPackages business={business} />}
    </Box>
  );
};
